<template>
 <router-link :to="{name: 'orders-details-page', params: {id: order?.id}}">
   <div class="order-status d-flex ">
     <h6 class="title mb-2 text-start">COM ID #LU- {{index + 1}} </h6>
     <h6 class="text-end align-self-end"><span class="badge text-secondary style-1 ms-1 ">{{ order?.status }}</span></h6>
   </div>
   <div class="view-title">
       <ul>
         <li>
           <span>Nombre de plat</span>
           <span>{{order?.meal_sale_elements?.length}}</span>
         </li>
         <li>
           <span class="text-success">Total</span>
           <span class="text-success">{{ order?.total }} f</span>
         </li>
       </ul>
     </div>
   <div v-if="index != total-1" class="saprater"></div>
 </router-link>
</template>

<script setup>

import {onMounted} from "vue";

// eslint-disable-next-line no-undef
defineProps({
  order: {
    type: Object,
  },
  index: {
    type: Number,
    default: 0
  },
  total: {
    type: Number,
    default: 0
  }
})

onMounted(() => {
})

</script>

<style scoped>
.view-title{
  border: 0px;
  padding-top: 0px;
}
.saprater {
  padding-top: 10px;
}
.order-status {
  margin: 10px 0;
}
a{
  color: black;
}
</style>